<template>
  <div v-show="isReady">
    <select class="custom-select custom-select-lg country-select text-lg" @change="navigateToUrl">
      <slot></slot>
    </select>
  </div>
</template>


<script>
export default {
  name: "CountrySelect",
  methods: {
    navigateToUrl(event) {
      const target = event.target;
      const targetIndex = target.selectedIndex || 0;
      if (target?.tagName === 'SELECT') {
        const selectedOption = target.options[targetIndex];
        if (selectedOption) {
          const url = selectedOption.getAttribute('data-url');
          if (url) {
            window.location.href = url;
          }
        }
      }
    },
  },
  data() {
    return {
      isReady: false,
    };
  },
  mounted() {
    this.isReady = true;
  },
};
</script>